// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b51d0d4e","239":"d3eca5f2","732":"c49caecc"}[chunkId] + ".chunk.js";
};